import { searchSolution } from '@/api/solution';

export const statusList: ISolution.ISolutionStatus[] = ['Request', 'Approved', 'Rejected', 'Cancel', 'Closed', 'Block', 'Paid'];

export const requestGetSolutions = (
  params: ISolution.IRequest.ISearchSolution,
): Promise<ISolution.IResponse.ISolutionData> => {
  return new Promise((reslove, reject) => {
    searchSolution(params).then((res) => {
      reslove(res);
    }).catch((error) => {
      reject(error.message);
    });
  });
};
